import { useLocation, useNavigate } from "react-router-dom";
import { Box, MenuItem, Select, Tooltip } from "@mui/material";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";

const PORTALS = [
  { label: "Admin",   path: "/admin/course-list",                          prefix: "/admin"   },
  { label: "Student", path: `/${process.env.REACT_APP_STUDENT_PREFIX || "student"}`, prefix: `/${process.env.REACT_APP_STUDENT_PREFIX || "student"}` },
  { label: "Parent",  path: `/${process.env.REACT_APP_PARENT_PREFIX  || "parent"}`,  prefix: `/${process.env.REACT_APP_PARENT_PREFIX  || "parent"}`  },
  { label: "Tutor",   path: "/tutor",                                       prefix: "/tutor"   },
];

export default function TesterPortalSwitcher() {
  const role = localStorage.getItem("role");
  const location = useLocation();
  const navigate = useNavigate();

  if (role !== "tester" && role !== "admin") return null;

  const active = PORTALS.find((p) => location.pathname.startsWith(p.prefix));
  const activePrefix = active?.prefix ?? "";

  const handleChange = (e) => {
    const portal = PORTALS.find((p) => p.prefix === e.target.value);
    if (portal) navigate(portal.path);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, ml: 0.5 }}>
      <Tooltip title="Switch portal (Tester mode)" placement="bottom">
        <SwitchAccountIcon sx={{ fontSize: 16, color: "warning.main", flexShrink: 0 }} />
      </Tooltip>
        <Select
          size="small"
          value={activePrefix}
          onChange={handleChange}
          displayEmpty
          sx={{
            fontSize: 12,
            fontWeight: 700,
            color: "#fff",
            height: 30,
            minWidth: 100,
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.4)" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.7)" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "warning.main" },
            "& .MuiSelect-icon": { color: "#fff" },
            "& .MuiSelect-select": { py: 0, px: 1 },
            background: "rgba(255,255,255,0.12)",
            borderRadius: "8px",
          }}
        >
          {PORTALS.map((portal) => (
            <MenuItem key={portal.label} value={portal.prefix} sx={{ fontSize: 13 }}>
              {portal.label}
            </MenuItem>
          ))}
        </Select>
    </Box>
  );
}
